// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__Wk3s4","content":"style_content__QL5to","link":"style_link__30isY","icon":"style_icon__1QZmA","text":"style_text__3VqMn"};